import VendorsContainer from "./VendorsContainer";
export default VendorsContainer;
